import React, { useState } from 'react';
import './Analytics.css';

function Analytics() {
  const [selectedPeriod, setSelectedPeriod] = useState('month');

  const mockData = {
    daily: [45, 52, 48, 61, 55, 67, 59],
    monthly: [1200, 1350, 1180, 1420, 1300, 1580, 1450, 1620, 1380, 1510, 1670, 1590],
    yearly: [14500, 15200, 14800, 16200, 15900, 17100, 16800, 17500, 16900, 17200, 17800, 18100]
  };

  const getDataForPeriod = () => {
    switch(selectedPeriod) {
      case 'day': return mockData.daily;
      case 'month': return mockData.monthly;
      case 'year': return mockData.yearly;
      default: return mockData.monthly;
    }
  };

  const data = getDataForPeriod();
  const maxValue = Math.max(...data);
  const minValue = Math.min(...data);

  return (
    <div className="analytics">
      <div className="analytics-header">
        <h1>📊 Enerji Analitikleri</h1>
        <p>Tüketim verilerinizi detaylı olarak analiz edin</p>
      </div>

      <div className="analytics-controls">
        <div className="period-selector">
          <button 
            className={`period-btn ${selectedPeriod === 'realtime' ? 'active' : ''}`}
            onClick={() => setSelectedPeriod('realtime')}
          >
            ⚡ Gerçek Zamanlı
          </button>
          <button 
            className={`period-btn ${selectedPeriod === 'day' ? 'active' : ''}`}
            onClick={() => setSelectedPeriod('day')}
          >
            📊 Günlük
          </button>
          <button 
            className={`period-btn ${selectedPeriod === 'week' ? 'active' : ''}`}
            onClick={() => setSelectedPeriod('week')}
          >
            📈 Haftalık
          </button>
          <button 
            className={`period-btn ${selectedPeriod === 'month' ? 'active' : ''}`}
            onClick={() => setSelectedPeriod('month')}
          >
            📅 Aylık
          </button>
          <button 
            className={`period-btn ${selectedPeriod === 'quality' ? 'active' : ''}`}
            onClick={() => setSelectedPeriod('quality')}
          >
            🔍 Enerji Kalitesi
          </button>
        </div>
      </div>

      <div className="analytics-content">
        <div className="chart-container">
          <h3>Tüketim Grafiği ({selectedPeriod === 'day' ? 'Son 7 Gün' : selectedPeriod === 'month' ? 'Son 12 Ay' : 'Son 5 Yıl'})</h3>
          <div className="chart">
            {data.map((value, index) => (
              <div key={index} className="chart-bar-container">
                <div 
                  className="chart-bar"
                  style={{
                    height: `${(value / maxValue) * 200}px`,
                    backgroundColor: value === maxValue ? '#FFD700' : value === minValue ? '#FFA500' : '#FFD700'
                  }}
                ></div>
                <div className="chart-label">{value}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <h4>⚡ Anlık Güç</h4>
            <div className="stat-value">2,450 kW</div>
            <div className="stat-change">Gerçek zamanlı</div>
          </div>
          <div className="stat-card">
            <h4>📊 Güç Faktörü</h4>
            <div className="stat-value">0.92</div>
            <div className="stat-change positive">Optimal seviye</div>
          </div>
          <div className="stat-card">
            <h4>🔍 Harmonik Distorsiyon</h4>
            <div className="stat-value">%3.2</div>
            <div className="stat-change negative">Hafif yüksek</div>
          </div>
          <div className="stat-card">
            <h4>⚡ Reaktif Enerji</h4>
            <div className="stat-value">450 kVAr</div>
            <div className="stat-change positive">Kompanze edilmiş</div>
          </div>
          <div className="stat-card">
            <h4>💰 Günlük Maliyet</h4>
            <div className="stat-value">₺2,847</div>
            <div className="stat-change">₺0.63/kWh</div>
          </div>
          <div className="stat-card">
            <h4>🌡️ Sıcaklık</h4>
            <div className="stat-value">42°C</div>
            <div className="stat-change negative">Yüksek</div>
          </div>
        </div>

        <div className="insights">
          <h3>🤖 AI Destekli Analiz ve Öngörüler</h3>
          <div className="insight-card">
            <p><strong>🔍 Anomali Tespiti:</strong> Sistem normal dışı tüketim paternleri tespit etti. 14:30-15:45 arası %15 artış gözlendi.</p>
          </div>
          <div className="insight-card">
            <p><strong>📈 Trend Analizi:</strong> Gelecek hafta için tahmini tüketim: 48,500 kWh (±5% güven aralığı)</p>
          </div>
          <div className="insight-card">
            <p><strong>⚡ Enerji Kalitesi:</strong> Gerilim dalgalanması %2.1 (Normal: %5). Harmonik distorsiyon izlenmeli.</p>
          </div>
          <div className="insight-card">
            <p><strong>💰 Maliyet Optimizasyonu:</strong> Reaktif enerji tüketimi optimal seviyede. Kompanzasyon sistemi verimli çalışıyor.</p>
          </div>
          <div className="insight-card">
            <p><strong>🔔 Kritik Uyarı:</strong> Trafo sıcaklığı yüksek (42°C). Bakım planlaması önerilir.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Analytics;
